import { DbRef } from "./firebase";
export const DUMMY_PLACE_GROUP_ID = 'dummyPlaceGroupID';
export var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["MONDAY"] = "monday";
    DayOfWeek["TUESDAY"] = "tuesday";
    DayOfWeek["WEDNESDAY"] = "wednesday";
    DayOfWeek["THURSDAY"] = "thursday";
    DayOfWeek["FRIDAY"] = "friday";
    DayOfWeek["SATURDAY"] = "saturday";
    DayOfWeek["SUNDAY"] = "sunday";
})(DayOfWeek || (DayOfWeek = {}));
export const orderedDaysOfWeek = [
    DayOfWeek.MONDAY,
    DayOfWeek.TUESDAY,
    DayOfWeek.WEDNESDAY,
    DayOfWeek.THURSDAY,
    DayOfWeek.FRIDAY,
    DayOfWeek.SATURDAY,
    DayOfWeek.SUNDAY,
];
export const PlaceGroupRelationshipKeys = {
    officeID: { ref: DbRef.OFFICES },
    placeGroupTypeID: { ref: DbRef.PLACE_GROUP_TYPES },
    places: { ref: DbRef.PLACES },
};
export var PlaceGroupTypeKind;
(function (PlaceGroupTypeKind) {
    PlaceGroupTypeKind["LAB"] = "lab";
    PlaceGroupTypeKind["FACILITY"] = "facility";
    PlaceGroupTypeKind["STAFFING"] = "staffing";
})(PlaceGroupTypeKind || (PlaceGroupTypeKind = {}));
export const PlaceGroupTypeRelationshipKeys = {
    placeGroups: { ref: DbRef.PLACE_GROUPS },
};
export var ResultsPreference;
(function (ResultsPreference) {
    ResultsPreference["FAX"] = "fax";
    ResultsPreference["PHONE"] = "phone";
})(ResultsPreference || (ResultsPreference = {}));
/**
 * _tags field created on algolia from Place object
 * MANAGES_INVENTORY -> place.placeGroup -> placeGroup.placeGroupType -> placeGroupType.managesInventory
 */
export var AlgoliaPlaceTag;
(function (AlgoliaPlaceTag) {
    AlgoliaPlaceTag["MANAGES_INVENTORY"] = "managesInventory";
})(AlgoliaPlaceTag || (AlgoliaPlaceTag = {}));
export const PlaceRelationshipKeys = {
    placeGroupID: { ref: DbRef.PLACE_GROUPS },
};
//# sourceMappingURL=places.js.map